"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Live auf einer Gastseite
// ============================================================
// Umschliesst eine Seite, die man ohne Konto erreicht (geteilter
// Link, Kundenfreigabe, Angebotsfreigabe). Bringt die Seite ein
// Ticket mit, wird es zuerst gegen die Gastsitzung getauscht; erst
// danach geht die Leitung auf. Andersherum koennte ein Ereignis vor
// der Sitzung ankommen, das Auffrischen zaehlte als neuer Aufruf.
// Warum es die Sitzung braucht, steht in `lib/live/gast.ts`.
// ============================================================

import { useEffect, useState } from "react";
import { gastSitzungAnnehmen } from "@/lib/live/gast-actions";
import type { GastBereich } from "@/lib/live/gast";
import { LiveProvider } from "./live-provider";

export function GastLive({
  bereich,
  token,
  ticket,
  sitzung,
  children,
}: {
  bereich: GastBereich;
  token: string;
  /** Aus dem Zeichnen, das den Aufruf gezaehlt hat. `null` mit Sitzung. */
  ticket: string | null;
  /** Der Browser hat schon eine gueltige Gastsitzung. */
  sitzung: boolean;
  children: React.ReactNode;
}) {
  const [angenommen, setAngenommen] = useState(false);
  const bereit = sitzung || angenommen;

  useEffect(() => {
    if (sitzung || !ticket) return;
    let aktiv = true;
    gastSitzungAnnehmen(bereich, token, ticket)
      .then((ok) => {
        if (aktiv && ok) setAngenommen(true);
      })
      .catch(() => {
        // Ohne Sitzung bleibt die Seite, wie sie ist — nur nicht live.
      });
    return () => {
      aktiv = false;
    };
  }, [bereich, token, ticket, sitzung]);

  return (
    <LiveProvider source={bereit ? `/api/live?gast=${bereich}:${token}` : null}>
      {children}
    </LiveProvider>
  );
}
